const CookieStorageService = (function() {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setToken(tokenObj) {
    const expires = new Date();
    expires.setDate(Date.now() + tokenObj.expiresIn * 1000);
    localStorage.setItem(
      "session",
      JSON.stringify({
        access_token: tokenObj.accessToken,
        expires_in: tokenObj.expiresIn,
        created_at: Date.now(),
      })
    );
  }
  function _getAccessToken() {
    return (
      localStorage.getItem("session") &&
      JSON.parse(localStorage.getItem("session"))
    );
  }
  function _getRefreshToken() {
    return (
      localStorage.getItem("session") &&
      JSON.parse(localStorage.getItem("session"))
    );
  }
  function _clearAll() {
    localStorage.clear();
    localStorage.removeItem("session");
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearAll: _clearAll
  };
})();
export default CookieStorageService;
